import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PatientDashboard from '../components/Patient/PatientDashboard';
import DigitalCard from '../components/Patient/DigitalCard';
import PrescriptionHistory from '../components/Patient/PrescriptionHistory';
import ReimbursementStatus from '../components/Patient/ReimbursementStatus';

const PatientPage = () => {
  return (
    <div className="page-content">
      <Routes>
        <Route index element={<PatientDashboard />} />
        <Route path="card" element={<DigitalCard />} />
        <Route path="prescriptions" element={<PrescriptionHistory />} />
        <Route path="remboursements" element={<ReimbursementStatus />} />
      </Routes>
    </div>
  );
};

export default PatientPage;